globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};
appCustomerSpace.LimitlessPlugins.ColorPickers = appCustomerSpace.LimitlessPlugins.ColorPickers || {};

appCustomerSpace.LimitlessPlugins.ColorPickers.Hex = (function(){

  Hex.selector = '[data-plugin="limitless.colorpickers.hex"]';

  Hex.init = function($html) {
    $html.find(Hex.selector).each(function() {
      new Hex($(this));
    })
  }

  function Hex($html) {
    this.$html = $html;
    this.$input = this.$html.closest('.input-group').find('.form-control');
    this.init();
  }

  Hex.prototype = {
    init: function(){
      var Hex = this,
          options = this.$html.data('plugin-options') || {},
          $modal = this.$html.closest('.modal-content'),
          defaults = {
            preferredFormat: 'hex',
            chooseText: 'Choisir',
            cancelText: 'Annuler',
            allowEmpty: false,
            showInput: options.showInput || false,
            showPalette: options.showPalette || false,
            showSelectionPalette: options.showSelectionPalette || false,
            palette: options.palette || [],
            change: function(c) {
              Hex.$input.val(c).trigger('change');
            },
            move: function(c) {
              Hex.$input.val(c);
            }
          };

      if ($modal.length) { defaults.appendTo = $modal; }

      Hex.$html.spectrum($.extend({}, defaults, options, true));

      Hex.$input.on('click', function(){
        Hex.$html.spectrum('toggle');
        return false;
      });

      Hex.$input.on('change', function(){
        var currentC = Hex.$html.spectrum('get'),
            newC = $(this).val();

        if(currentC != newC) Hex.$html.spectrum('set', newC);
      });
    },
  }

  return Hex;
})();
